import QuestionResult from "../QuestionResult";
import { useSelector } from "react-redux";
import classes from "./ResultsScreen.module.scss";

export default function ResultsScreen(props) {
  const { questions } = props;

  const showAnswers = useSelector((state) => state.game.showSolutions);

  return (
    <div className={classes.container}>
      {questions.map((question) => (
        <QuestionResult
          key={question.id}
          question={question}
          numberOfQuestions={questions.length}
          showAnswers={showAnswers}
        />
      ))}
    </div>
  );
}
